import AppBar from '@/common/components/layouts/appBar';
import { LayoutWithHeaderAndFooter } from '@/common/components/layouts/layoutWithHeaderAndFooter';
import Seo from '@/common/components/layouts/seo';
import useIsNewAppShell from '@/common/hooks/useIsNewAppShell';
import useResponsive from '@/common/hooks/useResponsive';
import { SideBar } from '@/modules/dashboard/layouts/sidebar';
import { ReactNode } from 'react';

interface PanelShellProps {
  title: string;
  /** props.config from the page (layout config from withServerUtils) */
  config?: any;
  children: ReactNode;
}

/** Same chrome as the iframe pages (app bar on mobile, dashboard sidebar on desktop), content is native. */
export const PanelShell = ({ title, config, children }: PanelShellProps) => {
  const { isMobile } = useResponsive();
  const isNewApp = useIsNewAppShell();
  return (
    <LayoutWithHeaderAndFooter {...config} shouldShowPromoteApp={false} showFooter={false} showHeader={!isMobile} className="!h-svh !min-h-svh !max-h-svh:">
      <AppBar title={title} className="md:hidden" backButton={!isNewApp} />
      <SideBar className="hidden md:flex">
        <div className="flex flex-grow flex-col w-full">
          <Seo title={title} noIndex />
          <div className="flex md:h-[calc(100vh-80px)] flex-col flex-grow w-full overflow-y-auto bg-[#f7f7f8]">{children}</div>
        </div>
      </SideBar>
    </LayoutWithHeaderAndFooter>
  );
};
